
import type { AxiosResponse } from "axios";
import type { TempFileStoreAccessToken } from "./S3Uploader";
import { API_URL } from "src/AppConstants";
import api from "src/utils/axios";

export const s3Endpoints = {
    GET_S3_TOKEN_URL: `${API_URL}/s3fileupload/GetToken`,
    GET_CDN_COOKIE_URL: `${API_URL}/amazon/cloudfront/cookies/url`
}

export async function S3TokenAccessor() {

    let response: AxiosResponse;
    try {
        response = await api.get<TempFileStoreAccessToken>(s3Endpoints.GET_S3_TOKEN_URL);
    }
    catch (error) {
        console.error("Error fetching token:", error);
        throw error;
    }

    if (!response) {
        throw new Error("No response received from the server.");
    }

    return response.data as TempFileStoreAccessToken;

}
